import { getContentByUrl } from 'widgets/toolbox/ajax';

/**
 * @description Base CountrySelectHamburgerMenuItem implementation
 * @param HamburgerMenuItem Base widget for extending
 * @returns CountrySelectHamburgerMenuItem widget
 */
export default function (HamburgerMenuItem: ReturnType<typeof import('widgets/header/HamburgerMenuItem').default>) {
    /**
     * @category widgets
     * @subcategory header
     * @class CountrySelectHamburgerMenuItem
     * @augments HamburgerMenuItem
     */
    class CountrySelectHamburgerMenuItem extends HamburgerMenuItem {
        prefs() {
            return {
                countrySelectMenuItem: 'countrySelectMenuItem',
                actionUrl: '',
                ...super.prefs()
            };
        }

        /**
         * @description Open next menu level if exist
         * @emits HamburgerMenuItem#navPanelNextLevel
         */
        openMenu(): void {
            this.getContent().then(() => {
                let submenuHTML;
                let itemLinkRefEl;
                let title;

                this.has(this.prefs().itemLink, (itemLink) => {
                    itemLinkRefEl = itemLink;
                });
                this.has(this.prefs().submenu, (submenu) => {
                    const submenuElement = submenu.get();

                    title = submenu.data('panelTitle');

                    if (submenuElement) {
                        submenuHTML = submenuElement.innerHTML;
                    }
                });
                /**
                 * @description Event to open nav panel next level
                 * @event HamburgerMenuItem#navPanelNextLevel
                 */
                this.eventBus().emit('nav.panel.next.level', {
                    htmlMarkup: submenuHTML,
                    parentMenuItem: itemLinkRefEl,
                    title: title
                });
            });
        }

        getContent() {
            return getContentByUrl(this.prefs().actionUrl)
                .then((response) => {
                    return this.render(undefined, {}, this.ref(this.prefs().countrySelectMenuItem), String(response))
                        .then(() => response);
                })
                .catch(() => {
                    this.eventBus().emit('alert.show', { errorCode: 500 });

                    return Promise.resolve(null);
                });
        }
    }

    return CountrySelectHamburgerMenuItem;
}
